import { ENDPOINTS } from '../../service/services';
import Api from '../../store/Interceptor/marketingInterceptor';

export const refreshToken = async () => {
  try {
    const response = await Api.get(ENDPOINTS.REFRESH_TOKEN_AUTH, {
      headers: {
        'application-key': process.env.INVOICING_APP_APPLICATION_KEY
      }
    });
    return response?.data;
  } catch (error) {
    console.error('Refresh token failed:', error.response || error.message);
    throw error; // Re-throw for handling in calling component
  }
};
